function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import PropTypes from "prop-types";
import React, { useContext } from "react";
import Base from "../Base/Base";
import PlatformContext from "./PlatformContext";
export default function Canvas({
  children,
  ...rest
}) {
  const {
    openConsoleWidth,
    openConsolePosition
  } = useContext(PlatformContext);
  const style = {
    marginLeft: openConsolePosition === "left" && openConsoleWidth,
    marginRight: openConsolePosition === "right" && openConsoleWidth
  };
  return /*#__PURE__*/React.createElement(Base, _extends({}, rest, {
    className: "ax-platform__canvas",
    style: style
  }), children);
}